enum ModeloEspecifico {
    Romaneio = 1,
}

export default ModeloEspecifico;
